import { FloatingPortal, useFloating, useHover, useInteractions } from "@floating-ui/react";
import { ReactNode, useState } from "react";

export default function FloatingOverlay({ overlayComponent, children }: { overlayComponent: ReactNode; children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);
	const { refs, floatingStyles, context } = useFloating({
		open: isOpen,
		onOpenChange: setIsOpen,
	});
	const hover = useHover(context);
	const { getReferenceProps, getFloatingProps } = useInteractions([hover]);
	return (
		<>
			<div ref={refs.setReference} {...getReferenceProps()}>
				{children}
			</div>
			{isOpen && (
                <FloatingPortal>
                    <div ref={refs.setFloating} style={{...floatingStyles, zIndex: 1080}} className="tooltip bs-tooltip-auto fade show" role="tooltip" {...getFloatingProps()}>
                        {overlayComponent}
                    </div>
                </FloatingPortal>
			)}
		</>
	);
}
